// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 4V9H2V2H9V4H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 4V9H22V2H15V4H20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 15V20H9V22H2V15H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 20V15H22V22H15V20H20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 7C13.6569 7 15 8.34315 15 10C15 11.1842 14.3139 12.2081 13.3175 12.696C15.16 13.2593 16.5 14.9731 16.5 17L16.5 17.9972H7.5L7.5 17C7.5 14.9731 8.84003 13.2593 10.6825 12.696C9.6861 12.2081 9 11.1842 9 10C9 8.34315 10.3431 7 12 7Z"}}]};

const PortraitFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'portrait-filled',
    ref,
    icon: element,
  },
));

PortraitFilledIcon.displayName = 'PortraitFilledIcon';

export default PortraitFilledIcon;
